import { Select } from "../../../../components/forms/select";

export type StyledSelectOption = { value: string; label: string };

export function StyledSelect({
  label,
  value,
  onChange,
  options,
  placeholder = "Select",
  compact = false,
  disabled = false,
  loading = false,
  error,
  searchable = false,
  required = false,
}: {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  options: ReadonlyArray<string | StyledSelectOption>;
  placeholder?: string;
  compact?: boolean;
  disabled?: boolean;
  loading?: boolean;
  error?: string;
  searchable?: boolean;
  required?: boolean;
}) {
  const normalized: StyledSelectOption[] = options.map((o) =>
    typeof o === "string" ? { value: o, label: o } : o,
  );
  return (
    <Select
      name={label ?? "select"}
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={normalized}
      placeholder={loading ? "Loading…" : placeholder}
      density={compact ? "compact" : "default"}
      disabled={disabled || loading}
      error={error}
      searchable={searchable}
      required={required}
    />
  );
}
